import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";

const postPromoteSatellite = (groupId, satelliteId, missionId, data) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/promoteToOperate?groupId=${groupId}&satId=${satelliteId}&missionId=${missionId}`, data);
};

const updatePromoteSatellite = (trueTwinId, data) => {
    return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/promoteToOperate?truetwinId=${trueTwinId}`, data);
};

const deletePromoteSatellite = (mission_id, trueTwinId) => {
    return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/promoteToOperate?missionId=${mission_id}&truetwinId=${trueTwinId}`);
};
const getPromotedSatellite = (trueTwinId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/promoteToOperate?truetwinId=${trueTwinId}`);
};
const getAllPromotedSatellites = (missionId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/promoteToOperate`);
};
const getProvider = (satId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/GetProvidersBySatelliteId?satId=${satId}`);
};
const addSchedule = (scenarioId, trueTwinId, data) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/addSchedule?groundStationId=${"G1"}&scenarioid=${scenarioId}&trueTwinId=${trueTwinId}`, data)
}
const exportSchedule = (missionId, scenarioId, scheduleId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/operate/${scenarioId}/exportschedule/${scheduleId}`);
}

const deleteSchedule = (missionId, scenarioId, scheduleId) => {
    return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/operate/${scenarioId}/onboardschedule/${scheduleId}`);
}


const OperateService = {
    postPromoteSatellite,
    updatePromoteSatellite,
    deletePromoteSatellite,
    getPromotedSatellite,
    getAllPromotedSatellites,
    addSchedule,
    getProvider,
    exportSchedule,
    deleteSchedule
};
export default OperateService;
